import { formatInternational } from "../../../common/phoneNumberHelpers";
import { Customer, CustomerInformationDrawerData } from "./types";

const getPatientInformationCardProps = (params: {
  customer: Customer;
  handlePatientClick: (mrn: string) => void;
}) => {
  const { customer, handlePatientClick } = params;
  const { mobile_phone_number, additional_phone_number, email } = customer;

  const patients = customer.patients?.map((patient) => ({
    id: patient.mrn,
    firstName: patient.first_name,
    lastName: patient.last_name,
    onClick: () => handlePatientClick(patient.mrn),
  }));

  const wardMrns = new Set(customer.patients?.map((p) => p.mrn));
  const familyMembers = customer.familyMembers
    ?.filter((fm) => !wardMrns.has(fm.mrn))
    .map((fm) => ({
      id: fm.mrn,
      firstName: fm.first_name,
      lastName: fm.last_name,
      onClick: () => handlePatientClick(fm.mrn),
    }));

  const customerInformation: CustomerInformationDrawerData["customerInformationCardProps"] =
    { email, patients, familyMembers };

  if (mobile_phone_number) {
    const styled = formatInternational({
      phoneNumber: mobile_phone_number,
    });
    customerInformation.phoneNumber = {
      url: mobile_phone_number,
      styled,
    };
  }

  if (additional_phone_number) {
    const styled = formatInternational({
      phoneNumber: additional_phone_number,
    });
    customerInformation.additionalPhoneNumber = {
      url: additional_phone_number,
      styled,
    };
  }

  return customerInformation;
};

export default getPatientInformationCardProps;
